var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundcloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6.75C11 6.33579 11.3358 6 11.75 6C13.3755 6 14.6891 6.40829 15.672 7.23996C16.5036 7.94368 17.0342 8.8962 17.3419 10H17.75C18.6569 10 19.5828 10.4102 20.2768 11.0522C20.979 11.7018 21.5 12.6418 21.5 13.75C21.5 15.8461 19.6389 17.5 17.75 17.5H11.75C11.3358 17.5 11 17.1642 11 16.75V6.75ZM12.5 7.5374V16H17.75C18.8611 16 20 14.9679 20 13.75C20 13.1322 19.711 12.5722 19.2582 12.1533C18.7972 11.7268 18.2231 11.5 17.75 11.5H16.75C16.3925 11.5 16.0847 11.2477 16.0146 10.8971C15.7865 9.75701 15.3484 8.93113 14.703 8.38504C14.1852 7.94688 13.476 7.63984 12.5 7.5374ZM8.75 7C9.16421 7 9.5 7.33579 9.5 7.75V16.75C9.5 17.1642 9.16421 17.5 8.75 17.5C8.33579 17.5 8 17.1642 8 16.75V7.75C8 7.33579 8.33579 7 8.75 7ZM5.75 9C6.16421 9 6.5 9.33579 6.5 9.75V16.75C6.5 17.1642 6.16421 17.5 5.75 17.5C5.33579 17.5 5 17.1642 5 16.75V9.75C5 9.33579 5.33579 9 5.75 9ZM2.75 13C3.16421 13 3.5 13.3358 3.5 13.75V15.75C3.5 16.1642 3.16421 16.5 2.75 16.5C2.33579 16.5 2 16.1642 2 15.75V13.75C2 13.3358 2.33579 13 2.75 13Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.dd8ddf41f79609c8893b10fd093c365d.svg";
export { ForwardRef as ReactComponent };